import React, {useState, useEffect, useMemo} from 'react'
import {Dropdown} from 'react-bootstrap'
import Select from 'react-select'
import {useQuery} from 'react-query'
import axios from 'axios'
import {KTSVG} from '../../../../_metronic/helpers/components/KTSVG'
import Tooltip from 'react-bootstrap/Tooltip'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import {CommonLoading} from '../../../../Utils/commonLoading'
import {useAuth} from '../../../modules/auth'
import {Form, Formik} from 'formik'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../../redux/store'
import LazySelect from '../../../components/LazySelect'
import {AI_NOISE_LEVEL_OPTIONS} from '../../../UI/configuration-management/components/AiNoiseBadge'
import {
  dashboardCallLogsEffectiffCurrentPage,
  dashboardCallLogsEffectiffFilter,
  dashboardCallLogsEffectiffRowsPerPage,
  dashboardCallLogsInPersonCurrentPage,
  dashboardCallLogsInPersonFilter,
  dashboardCallLogsInPersonRowsPerPage,
  dashboardCallLogsOnDEmandCurrentPage,
  dashboardCallLogsOnDEmandFilter,
  dashboardCallLogsOnDEmandRowsPerPage,
  dashboardCallLogsOperatorCurrentPage,
  dashboardCallLogsOperatorFilter,
  dashboardCallLogsOperatorRowsPerPage,
  dashboardCallLogsScheduledCurrentPage,
  dashboardCallLogsScheduledFilter,
  dashboardCallLogsScheduledRowsPerPage,
  dashboardCallLogsOPICurrentPage,
  dashboardCallLogsOPIFilter,
  dashboardCallLogsOPIRowsPerPage,
} from '../../../redux/tableSlice/tableSlice'
import {useInterpreters, useServiceTypes} from '../../../hooks/useGlobalData'

const API_URL = process.env.REACT_APP_API_URL

type Props = {
  setcall_log: any
  setCurrentPage: any
  setTotalPages: React.Dispatch<React.SetStateAction<number>>
  setFilterData: any
  fetchcall_log: any
  searchQuery: any
  callType: number
  useOPIActions?: boolean // Flag to use OPI Redux actions instead of OnDemand for callType 1
}

export function LogsFilterDropdown({
  setcall_log,
  setCurrentPage,
  setTotalPages,
  setFilterData,
  fetchcall_log,
  searchQuery,
  callType,
  useOPIActions = false,
}: Props) {
  const [isLoading, setIsLoading] = useState(false)
  const {currentUser} = useAuth()
  const isSystemUser = currentUser?.result?.userType === 'SYSTEM'
  const showAiQcFilter =
    isSystemUser && (useOPIActions || callType === 0 || callType === 1)
  const showCallTagsFilter =
    isSystemUser && (useOPIActions || callType === 1)
  const dispatch = useDispatch()
  const [showDropdownMenu, setShowDropdownMenu] = useState(false)
  const [isFilterApplied, setIsFilterApplied] = useState(false)
  const {items: responseLanguage, loading: isFetchingLanguage} = useSelector(
    (state: RootState) => state.languages
  )
  const {rowsPerPage} = useSelector((state: RootState) => {
    if (callType === 1 && useOPIActions) {
      return {
        rowsPerPage: state.table.dashboardCallLogsOPI[0].rowsPerPage,
      }
    } else if (callType === 1) {
      return {
        rowsPerPage: state.table.dashboardCallLogsOnDEmand[0].rowsPerPage,
      }
    } else if (callType === 2) {
      return {
        rowsPerPage: state.table.dashboardCallLogsInPerson[0].rowsPerPage,
      }
    } else if (callType === 3) {
      return {
        rowsPerPage: state.table.dashboardCallLogsOperator[0].rowsPerPage,
      }
    } else if (callType === 0) {
      return {
        rowsPerPage: state.table.dashboardCallLogsScheduled[0].rowsPerPage,
      }
    } else if (callType === 5) {
      return {
        rowsPerPage: state.table.dashboardCallLogsEffectiff[0].rowsPerPage,
      }
    } else {
      return {
        rowsPerPage: 10,
      }
    }
  })
  const {items: responseRequesters, loading: isFetchingRequesters} = useSelector(
    (state: RootState) => state.awsRequesters
  )
  const languageOptions =
    responseLanguage?.map((d) => ({
      value: d.key ?? '',
      label: d.value ?? '',
    })) ?? []

  useEffect(() => {
    if (
      (setFilterData?.awsUserId_REQList?.length ?? 0) > 0 ||
      (setFilterData?.awsUserId_INTList?.length ?? 0) > 0 ||
      (setFilterData?.customerList?.length ?? 0) > 0 ||
      (setFilterData?.languageList?.length ?? 0) > 0 ||
      (setFilterData?.callStateList?.length ?? 0) > 0 ||
      (setFilterData?.serviceTypeList?.length ?? 0) > 0 ||
      (setFilterData?.backstopPartnerList?.length ?? 0) > 0 ||
      !!setFilterData?.aiQcStatus ||
      (setFilterData?.noiseLevels?.length ?? 0) > 0 ||
      (setFilterData?.tagIds?.length ?? 0) > 0 ||
      (setFilterData?.startDate !== null && setFilterData?.startDate !== undefined) ||
      (setFilterData?.endDate !== null && setFilterData?.endDate !== undefined)
    ) {
      setIsFilterApplied(true)
    } else {
      setIsFilterApplied(false)
    }
  }, [setFilterData])

  const requesterOptions =
    responseRequesters?.map((d: {key: any; value: any}) => ({
      value: d.key ?? '',
      label: d.value ?? '',
    })) ?? []

  const {items: responseCustomer, loading: isFetchingCustomer} = useSelector(
    (state: RootState) => state.customers
  )

  // Use global cached data for interpreters
  const {data: interpretersData, isLoading: isFetchingInterpreter} = useInterpreters()

  const interpreterOptions = useMemo(() => 
    interpretersData?.map((d: any) => ({value: d.key ?? '', label: d.value ?? ''})) ?? []
  , [interpretersData])
  
  const customerOptions = useMemo(() => 
    responseCustomer?.map((d) => ({value: String(d.key ?? ''), label: d.value ?? ''})) ?? []
  , [responseCustomer])

  const callStatusOptions = [
    {value: 'CNT', label: 'Connected'},
    {value: 'ABD', label: 'Abandoned'},
  ]
  const {data: serviceTypesData} = useServiceTypes({enabled: isSystemUser})
  const serviceTypeOptions = useMemo(() =>
    serviceTypesData?.map((d: any) => ({value: String(d.key ?? ''), label: d.value ?? ''})) ?? []
  , [serviceTypesData])
  const {data: backstopPartnersData} = useQuery(
    ['logs-filter-backstop-partners'],
    async () => {
      const response = await axios.get(`${API_URL}/master/backstop-partners-shortlist`)
      return response.data.data || []
    },
    {enabled: isSystemUser, refetchOnWindowFocus: false}
  )
  const backstopPartnerOptions = useMemo(() =>
    backstopPartnersData?.map((d: any) => ({
      value: Number(d.key),
      label: d.value ?? '',
    })) ?? []
  , [backstopPartnersData])
  const {data: callTagsData} = useQuery(
    ['logs-filter-call-tags'],
    async () => {
      const response = await axios.get(`${API_URL}/call-tags`)
      return response?.data?.result ?? response?.data?.Result ?? []
    },
    {enabled: showCallTagsFilter, refetchOnWindowFocus: false}
  )
  const callTagOptions = useMemo(
    () =>
      (callTagsData || []).map((t: any) => ({
        value: Number(t.id ?? t.Id),
        label: String(t.name ?? t.Name ?? ''),
        color: String(t.color ?? t.Color ?? '#6B7280'),
      })),
    [callTagsData]
  )
  const [data, setdata] = useState({
    awsUserId_REQList: null,
    awsUserId_INTList: null,
    customerList: null,
    languageList: null,
    callStateList: null,
    serviceTypeList: null,
    backstopPartnerList: null,
    startDate: undefined,
    endDate: undefined,
    callType: callType,
    callTypeFilter: -1,
    aiQcStatus: '',
    noiseLevels: [] as string[],
    tagIds: [] as number[],
  })
  const handleSubmit = async (values: any) => {
    setIsLoading(true)
    try {
      const filterValues = {...values, callType}
      if (callType === 1 && useOPIActions) {
        dispatch(dashboardCallLogsOPICurrentPage(1))
        dispatch(dashboardCallLogsOPIFilter(filterValues))
      } else if (callType === 1) {
        dispatch(dashboardCallLogsOnDEmandCurrentPage(1))
        dispatch(dashboardCallLogsOnDEmandFilter(filterValues))
      }
      if (callType === 0) {
        dispatch(dashboardCallLogsScheduledCurrentPage(1))
        dispatch(dashboardCallLogsScheduledFilter(filterValues))
      }
      if (callType === 2) {
        dispatch(dashboardCallLogsInPersonCurrentPage(1))
        dispatch(dashboardCallLogsInPersonFilter(filterValues))
      }
      if (callType === 3) {
        dispatch(dashboardCallLogsOperatorCurrentPage(1))
        dispatch(dashboardCallLogsOperatorFilter(filterValues))
      }
      if (callType === 5) {
        dispatch(dashboardCallLogsEffectiffCurrentPage(1))
        dispatch(dashboardCallLogsEffectiffFilter(filterValues))
      }
      fetchcall_log(filterValues, searchQuery, 1, rowsPerPage)
      setIsFilterApplied(true)
    } catch (error) {
      console.error(error)
    } finally {
      setShowDropdownMenu(false)
      setIsLoading(false)
    }
  }

  const handleReset = async () => {
    const resetFilterData = {
      awsUserId_REQList: [],
      awsUserId_INTList: [],
      customerList: [],
      languageList: [],
      callStateList: [],
      serviceTypeList: [],
      backstopPartnerList: [],
      startDate: null,
      endDate: null,
      callType: callType,
      callTypeFilter: -1,
      aiQcStatus: '',
      noiseLevels: [],
      tagIds: [],
    }
    if (callType === 1 && useOPIActions) {
      dispatch(dashboardCallLogsOPICurrentPage(1))
      dispatch(dashboardCallLogsOPIFilter(resetFilterData))
      dispatch(dashboardCallLogsOPIRowsPerPage(10))
    } else if (callType === 1) {
      dispatch(dashboardCallLogsOnDEmandCurrentPage(1))
      dispatch(dashboardCallLogsOnDEmandFilter(resetFilterData))
      dispatch(dashboardCallLogsOnDEmandRowsPerPage(10))
    }
    if (callType === 0) {
      dispatch(dashboardCallLogsScheduledCurrentPage(1))
      dispatch(dashboardCallLogsScheduledFilter(resetFilterData))
      dispatch(dashboardCallLogsScheduledRowsPerPage(10))
    }
    if (callType === 2) {
      dispatch(dashboardCallLogsInPersonCurrentPage(1))
      dispatch(dashboardCallLogsInPersonFilter(resetFilterData))
      dispatch(dashboardCallLogsInPersonRowsPerPage(10))
    }
    if (callType === 3) {
      dispatch(dashboardCallLogsOperatorCurrentPage(1))
      dispatch(dashboardCallLogsOperatorFilter(resetFilterData))
      dispatch(dashboardCallLogsOperatorRowsPerPage(10))
    }
    if (callType === 5) {
      dispatch(dashboardCallLogsEffectiffCurrentPage(1))
      dispatch(dashboardCallLogsEffectiffFilter(resetFilterData))
      dispatch(dashboardCallLogsEffectiffRowsPerPage(10))
    }
    setShowDropdownMenu(false)
    fetchcall_log(resetFilterData, searchQuery, 1, 10)
    setIsFilterApplied(false)
  }

  return (
    <>
      <Dropdown onToggle={(nextShow) => setShowDropdownMenu(nextShow)}>
        <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip-filter'>Filter</Tooltip>}>
          <Dropdown.Toggle
            variant='primary'
            id='dropdown-basic'
            className={`btn btn-icon btn-sm no-caret ${isFilterApplied ? 'btn-light-danger' : ''}`}
          >
            <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-primary' />
          </Dropdown.Toggle>
        </OverlayTrigger>
        {showDropdownMenu && (
          <Dropdown.Menu className='p-4 w-350px' style={{minHeight: '100%'}}>
            <div className='px-4 pb-4'>
              <div className='fs-4 text-dark fw-semibolder'>Filter</div>
            </div>
            <Formik
              enableReinitialize
              initialValues={setFilterData}
              onSubmit={async (values, {setSubmitting, resetForm}) => {
                setSubmitting(true)
                setdata(values)
                handleSubmit(values)
              }}
            >
              {({
                isSubmitting,
                handleChange,
                handleBlur,
                setFieldTouched,
                setFieldValue,
                handleSubmit,
                resetForm,
                values,
                errors,
                touched,
                isValid,
                dirty,
                ...formik
              }) => (
                <Form>
                  <div className='separator border-gray-200'></div>
                  <div className='card px-4 mt-4'>
                    <div className='row flex-column'>
                      {currentUser?.result?.userType !== 'INTERPRETER' &&
                        currentUser?.result?.role !== 'User' && (
                          <div className='col-sm-12 col-md-12'>
                            <div className='mb-3'>
                              <div className='col-md-12'>
                                <div className='d-flex justify-content-between align-items-center'>
                                  <div>
                                    <label htmlFor='customers' className='form-label fs-7 mb-1'>
                                      Customer Name(s)
                                    </label>
                                  </div>
                                  <div className='form-check form-check-custom form-check-solid form-check-sm mb-2'>
                                    <input
                                      className='form-check-input'
                                      type='checkbox'
                                      checked={
                                        (values.customerList as unknown as string[])?.length ===
                                        customerOptions?.length
                                      }
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          setFieldValue(
                                            'customerList',
                                            customerOptions?.map((option: any) => option.value)
                                          )
                                        } else {
                                          setFieldValue('customerList', [])
                                        }
                                      }}
                                    />
                                    <label className='form-check-label' htmlFor='flexRadioLg1'>
                                      All
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div className='row g-4 g-xl-4'>
                                <div className='col-sm-12 col-md-12 col-lg-12'>
                                  <div className='w-100'>
                                    <LazySelect
                                      name='customerList'
                                      options={!isFetchingCustomer ? customerOptions : []}
                                      placeholder='Select Customer(s)'
                                      isMulti
                                      isLoading={isFetchingCustomer}
                                      value={
                                        customerOptions?.filter(
                                          (option: any) =>
                                            Array.isArray(values.customerList) &&
                                            (values.customerList as string[]).includes(option.value)
                                        ) || []
                                      }
                                      onChange={(selectedOptions: any[]) => {
                                        setFieldValue(
                                          'customerList',
                                          selectedOptions
                                            ? selectedOptions.map((option) => option.value)
                                            : []
                                        )
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      {currentUser?.result?.userType !== 'INTERPRETER' &&
                        currentUser?.result?.role !== 'User' && (
                          <div className='col-sm-12 col-md-12'>
                            <div className='mb-3'>
                              <div className='col-md-12'>
                                <div className='d-flex justify-content-between align-items-center'>
                                  <div>
                                    <label htmlFor='customerName' className='form-label fs-7 mb-1'>
                                      Requester(s)
                                    </label>
                                  </div>
                                  <div className='form-check form-check-custom form-check-solid form-check-sm mb-2'>
                                    <input
                                      className='form-check-input'
                                      type='checkbox'
                                      checked={
                                        requesterOptions?.length > 0 &&
                                        (values.awsUserId_REQList as unknown as string[])
                                          ?.length === requesterOptions?.length
                                      }
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          setFieldValue(
                                            'awsUserId_REQList',
                                            requesterOptions?.map((option: any) => option.value)
                                          )
                                        } else {
                                          setFieldValue('awsUserId_REQList', [])
                                        }
                                      }}
                                    />
                                    <label className='form-check-label' htmlFor='flexRadioLg1'>
                                      All
                                    </label>
                                  </div>
                                </div>
                              </div>

                              <div className='row g-4 g-xl-4'>
                                <div className='col-sm-12 col-md-12 col-lg-12'>
                                  <div className='w-100'>
                                    <LazySelect
                                      name='awsUserId_REQList'
                                      options={!isFetchingRequesters ? requesterOptions : []}
                                      placeholder='Select Requester(s)'
                                      isMulti
                                      isLoading={isFetchingRequesters}
                                      value={
                                        requesterOptions?.filter(
                                          (option: any) =>
                                            Array.isArray(values.awsUserId_REQList) &&
                                            (values.awsUserId_REQList as string[]).includes(
                                              option.value
                                            )
                                        ) || []
                                      }
                                      onChange={(selectedOptions: any[]) => {
                                        setFieldValue(
                                          'awsUserId_REQList',
                                          selectedOptions
                                            ? selectedOptions.map((option) => option.value)
                                            : []
                                        )
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      {currentUser?.result?.userType !== 'INTERPRETER' &&
                        currentUser?.result?.role !== 'User' && (
                          <div className='col-sm-12 col-md-12'>
                            <div className='mb-3'>
                              <div className='col-md-12'>
                                <div className='d-flex justify-content-between align-items-center'>
                                  <div>
                                    <label htmlFor='interpreters' className='form-label fs-7 mb-1'>
                                      Interpreter(s)
                                    </label>
                                  </div>
                                  <div className='form-check form-check-custom form-check-solid form-check-sm mb-2'>
                                    <input
                                      className='form-check-input'
                                      type='checkbox'
                                      checked={
                                        (values.awsUserId_INTList as unknown as string[])
                                          ?.length === interpreterOptions?.length
                                      }
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          setFieldValue(
                                            'awsUserId_INTList',
                                            interpreterOptions?.map((option: any) => option.value)
                                          )
                                        } else {
                                          setFieldValue('awsUserId_INTList', [])
                                        }
                                      }}
                                    />
                                    <label className='form-check-label' htmlFor='flexRadioLg1'>
                                      All
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div className='row g-4 g-xl-4'>
                                <div className='col-sm-12 col-md-12 col-lg-12'>
                                  <div className='w-100'>
                                    <LazySelect
                                      name='awsUserId_INTList'
                                      options={!isFetchingInterpreter ? interpreterOptions : []}
                                      placeholder='Select Interpreter(s)'
                                      isMulti
                                      isLoading={isFetchingInterpreter}
                                      value={
                                        interpreterOptions?.filter(
                                          (option: any) =>
                                            Array.isArray(values.awsUserId_INTList) &&
                                            (values.awsUserId_INTList as string[]).includes(
                                              option.value
                                            )
                                        ) || []
                                      }
                                      onChange={(selectedOptions: any[]) => {
                                        setFieldValue(
                                          'awsUserId_INTList',
                                          selectedOptions
                                            ? selectedOptions.map((option) => option.value)
                                            : []
                                        )
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      {useOPIActions && (
                        <div className='col-sm-12 col-md-12'>
                          <div className='mb-3'>
                            <div className='col-md-12'>
                              <div className='d-flex justify-content-between align-items-center'>
                                <div>
                                  <label htmlFor='callTypeFilter' className='form-label fs-7 mb-1'>
                                    Call Type
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div className='row g-4 g-xl-4'>
                              <div className='col-sm-12 col-md-12 col-lg-12'>
                                <div className='w-100'>
                                  <Select
                                    name='callTypeFilter'
                                    options={[
                                      {value: -1, label: 'All'},
                                      {value: 1, label: 'On Demand'},
                                      {value: 0, label: 'Scheduled'},
                                    ]}
                                    value={
                                      [
                                        {value: -1, label: 'All'},
                                        {value: 1, label: 'On Demand'},
                                        {value: 0, label: 'Scheduled'},
                                      ].find((opt) => opt.value === values.callTypeFilter) || {
                                        value: -1,
                                        label: 'All',
                                      }
                                    }
                                    onChange={(option: any) =>
                                      setFieldValue('callTypeFilter', option.value)
                                    }
                                    className='react-select-styled react-select-solid react-select-sm'
                                    classNamePrefix='react-select'
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {showAiQcFilter && (
                        <div className='col-sm-12 col-md-12'>
                          <div className='mb-3'>
                            <label htmlFor='aiQcStatus' className='form-label fs-7 mb-1'>
                              AI QC Status
                            </label>
                            <Select
                              name='aiQcStatus'
                              isClearable
                              options={[
                                {value: 'Pass', label: 'Pass'},
                                {value: 'Fail', label: 'Fail'},
                              ]}
                              value={
                                [
                                  {value: 'Pass', label: 'Pass'},
                                  {value: 'Fail', label: 'Fail'},
                                ].find((opt) => opt.value === values.aiQcStatus) ?? null
                              }
                              onChange={(option: {value: string} | null) =>
                                setFieldValue('aiQcStatus', option?.value ?? '')
                              }
                              placeholder='All'
                              className='react-select-styled react-select-solid react-select-sm'
                              classNamePrefix='react-select'
                            />
                          </div>
                        </div>
                      )}
                      {showAiQcFilter && (
                        <div className='col-sm-12 col-md-12'>
                          <div className='mb-3'>
                            <label htmlFor='noiseLevels' className='form-label fs-7 mb-1'>
                              AI Noise Detection
                            </label>
                            <Select
                              name='noiseLevels'
                              inputId='noiseLevels'
                              isMulti
                              isClearable
                              options={AI_NOISE_LEVEL_OPTIONS}
                              value={AI_NOISE_LEVEL_OPTIONS.filter((opt) =>
                                ((values.noiseLevels as string[]) || []).includes(opt.value)
                              )}
                              onChange={(selected: readonly {value: string}[] | null) =>
                                setFieldValue(
                                  'noiseLevels',
                                  selected ? selected.map((opt) => opt.value) : []
                                )
                              }
                              placeholder='All'
                              className='react-select-styled react-select-solid react-select-sm'
                              classNamePrefix='react-select'
                            />
                          </div>
                        </div>
                      )}
                      {showCallTagsFilter && (
                        <div className='col-sm-12 col-md-12'>
                          <div className='mb-3'>
                            <label htmlFor='tagIds' className='form-label fs-7 mb-1'>
                              Tags
                            </label>
                            <Select
                              name='tagIds'
                              isMulti
                              isSearchable
                              isClearable
                              options={callTagOptions}
                              value={callTagOptions.filter((opt: any) =>
                                ((values.tagIds as number[]) || []).includes(opt.value)
                              )}
                              onChange={(opts: any) =>
                                setFieldValue(
                                  'tagIds',
                                  opts ? opts.map((o: any) => o.value) : []
                                )
                              }
                              placeholder='Search tags'
                              className='react-select-styled react-select-solid react-select-sm'
                              classNamePrefix='react-select'
                              formatOptionLabel={(opt: any) => (
                                <div className='d-flex align-items-center gap-2'>
                                  <span
                                    className='rounded-circle d-inline-block'
                                    style={{
                                      width: 10,
                                      height: 10,
                                      backgroundColor: opt.color,
                                      flexShrink: 0,
                                    }}
                                  />
                                  <span>{opt.label}</span>
                                </div>
                              )}
                            />
                          </div>
                        </div>
                      )}
                      <div className='col-sm-12 col-md-12'>
                        <div className='mb-3'>
                          <div className='col-md-12'>
                            <div className='d-flex justify-content-between align-items-center'>
                              <div>
                                <label htmlFor='languages' className='form-label fs-7 mb-1'>
                                  Language(s)
                                </label>
                              </div>
                              <div className='form-check form-check-custom form-check-solid form-check-sm mb-2'>
                                <input
                                  className='form-check-input'
                                  type='checkbox'
                                  checked={
                                    (values.languageList as unknown as string[])?.length ===
                                    languageOptions?.length
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    setFieldValue(
                                      'languageList',
                                      e.target.checked
                                        ? languageOptions.map((option: any) => option.label)
                                        : []
                                    )
                                  }}
                                />
                                <label className='form-check-label' htmlFor='flexRadioLg1'>
                                  All
                                </label>
                              </div>
                            </div>
                          </div>

                          <div className='row g-4 g-xl-4'>
                            <div className='col-sm-12 col-md-12 col-lg-12'>
                              <div className='w-100'>
                                <LazySelect
                                  name='languageList'
                                  options={!isFetchingLanguage ? languageOptions : []}
                                  placeholder='Select language(s)'
                                  isMulti
                                  isLoading={isFetchingLanguage}
                                  value={
                                    languageOptions?.filter(
                                      (option: any) =>
                                        Array.isArray(values.languageList) &&
                                        (values.languageList as string[]).includes(option.label)
                                    ) || []
                                  }
                                  onChange={(selectedOptions: any[]) => {
                                    setFieldValue(
                                      'languageList',
                                      selectedOptions
                                        ? selectedOptions.map((option) => option.label)
                                        : []
                                    )
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {callType !== 3 && callType !== 4 && (
                        <div className='col-sm-12 col-md-12'>
                          <div className='mb-3'>
                            <div className='col-md-12'>
                              <div className='d-flex justify-content-between align-items-center'>
                                <div>
                                  <label htmlFor='serviceType' className='form-label fs-7 mb-1'>
                                    Call Status
                                  </label>
                                </div>
                                <div className='form-check form-check-custom form-check-solid form-check-sm mb-2'>
                                  <input
                                    className='form-check-input'
                                    type='checkbox'
                                    checked={
                                      (values?.callStateList as unknown as string[])?.length ===
                                      callStatusOptions?.length
                                    }
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setFieldValue(
                                          'callStateList',
                                          callStatusOptions?.map((option: any) => option.value)
                                        )
                                      } else {
                                        setFieldValue('callStateList', null)
                                      }
                                    }}
                                  />
                                  <label className='form-check-label' htmlFor='flexRadioLg1'>
                                    All
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div className='row g-4 g-xl-4'>
                              <div className='col-sm-12 col-md-12 col-lg-12'>
                                <div className='w-100'>
                                  <Select
                                    {...formik.getFieldProps('callStateList')}
                                    className='react-select-styled react-select-solid react-select-sm'
                                    classNamePrefix='react-select'
                                    options={callStatusOptions || []}
                                    placeholder='Select Call status'
                                    isMulti
                                    value={
                                      callStatusOptions?.filter(
                                        (option: any) =>
                                          Array.isArray(values.callStateList) &&
                                          (values.callStateList as string[]).includes(option.value)
                                      ) || []
                                    }
                                    onChange={(selectedOptions: any[]) =>
                                      setFieldValue(
                                        'callStateList',
                                        selectedOptions?.map((option) => option.value) || []
                                      )
                                    }
                                    styles={{
                                      control: (provided: any) => ({
                                        ...provided,
                                        width: '100%',
                                        border: '1px solid #e4e6ef',
                                      }),
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {isSystemUser && (
                        <div className='col-sm-12 col-md-12'>
                          <div className='mb-3'>
                            <div className='col-md-12'>
                              <div className='d-flex justify-content-between align-items-center'>
                                <div>
                                  <label htmlFor='backstopPartnerList' className='form-label fs-7 mb-1'>
                                    Backstop
                                  </label>
                                </div>
                                <div className='form-check form-check-custom form-check-solid form-check-sm mb-2'>
                                  <input
                                    className='form-check-input'
                                    type='checkbox'
                                    checked={
                                      backstopPartnerOptions.length > 0 &&
                                      (values?.backstopPartnerList as unknown as number[])?.length ===
                                        backstopPartnerOptions.length
                                    }
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setFieldValue(
                                          'backstopPartnerList',
                                          backstopPartnerOptions.map((option: any) => option.value)
                                        )
                                      } else {
                                        setFieldValue('backstopPartnerList', [])
                                      }
                                    }}
                                  />
                                  <label className='form-check-label' htmlFor='flexRadioLg1'>
                                    All
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div className='row g-4 g-xl-4'>
                              <div className='col-sm-12 col-md-12 col-lg-12'>
                                <div className='w-100'>
                                  <Select
                                    className='react-select-styled react-select-solid react-select-sm'
                                    classNamePrefix='react-select'
                                    options={backstopPartnerOptions || []}
                                    placeholder='Select Backstop'
                                    isMulti
                                    value={
                                      backstopPartnerOptions?.filter(
                                        (option: any) =>
                                          Array.isArray(values.backstopPartnerList) &&
                                          (values.backstopPartnerList as number[]).includes(option.value)
                                      ) || []
                                    }
                                    onChange={(selectedOptions: any[]) =>
                                      setFieldValue(
                                        'backstopPartnerList',
                                        selectedOptions?.map((option) => option.value) || []
                                      )
                                    }
                                    styles={{
                                      control: (provided: any) => ({
                                        ...provided,
                                        width: '100%',
                                        border: '1px solid #e4e6ef',
                                      }),
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {isSystemUser && (
                      <div className='col-sm-12 col-md-12'>
                        <div className='mb-3'>
                          <div className='col-md-12'>
                            <div className='d-flex justify-content-between align-items-center'>
                              <div>
                                <label htmlFor='serviceTypeList' className='form-label fs-7 mb-1'>
                                  Service Type
                                </label>
                              </div>
                              <div className='form-check form-check-custom form-check-solid form-check-sm mb-2'>
                                <input
                                  className='form-check-input'
                                  type='checkbox'
                                  checked={
                                    (values?.serviceTypeList as unknown as string[])?.length ===
                                    serviceTypeOptions?.length
                                  }
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setFieldValue(
                                        'serviceTypeList',
                                        serviceTypeOptions?.map((option: any) => option.value)
                                      )
                                    } else {
                                      setFieldValue('serviceTypeList', [])
                                    }
                                  }}
                                />
                                <label className='form-check-label' htmlFor='flexRadioLg1'>
                                  All
                                </label>
                              </div>
                            </div>
                          </div>

                          <div className='row g-4 g-xl-4'>
                            <div className='col-sm-12 col-md-12 col-lg-12'>
                              <div className='w-100'>
                                <Select
                                  {...formik.getFieldProps('serviceTypeList')}
                                  className='react-select-styled react-select-solid react-select-sm'
                                  classNamePrefix='react-select'
                                  options={serviceTypeOptions || []}
                                  placeholder='Select Service Type'
                                  isMulti
                                  value={
                                    serviceTypeOptions?.filter(
                                      (option: any) =>
                                        Array.isArray(values.serviceTypeList) &&
                                        (values.serviceTypeList as string[]).includes(option.value)
                                    ) || []
                                  }
                                  onChange={(selectedOptions: any[]) =>
                                    setFieldValue(
                                      'serviceTypeList',
                                      selectedOptions?.map((option) => option.value) || []
                                    )
                                  }
                                  styles={{
                                    control: (provided: any) => ({
                                      ...provided,
                                      width: '100%',
                                      border: '1px solid #e4e6ef',
                                    }),
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      )}
                      <div className='fv-row'>
                        <div className='row'>
                          <div className='col-sm-6'>
                            <label htmlFor='startDate' className='form-label fs-7 mb-1'>
                              Start Date
                            </label>
                            <input
                              {...formik.getFieldProps('startDate')}
                              type='date'
                              className='form-control form-control-white form-select-sm custom-input-height'
                              value={values.startDate}
                              onChange={(e) => setFieldValue('startDate', e.target.value)}
                              placeholder='Enter Subject'
                            />
                          </div>
                          <div className='col-sm-6'>
                            <label htmlFor='endDate' className='form-label fs-7 mb-1'>
                              End Date
                            </label>
                            <input
                              {...formik.getFieldProps('endDate')}
                              type='date'
                              className='form-control form-control-white form-select-sm custom-input-height'
                              value={values.endDate}
                              onChange={(e) => setFieldValue('endDate', e.target.value)}
                              placeholder='Start Time'
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='text-end pt-5 px-4'>
                    <button
                      type='reset'
                      className='btn btn-sm btn-light me-2'
                      data-kt-menu-dismiss='true'
                      onClick={handleReset}
                    >
                      Reset
                    </button>

                    <button
                      type='submit'
                      className='btn btn-sm btn-primary'
                      data-kt-menu-dismiss='true'
                      disabled={isSubmitting}
                    >
                      Apply
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </Dropdown.Menu>
        )}
      </Dropdown>
      {isLoading && <CommonLoading />}
    </>
  )
}
